// Models
import { Assignment } from "./Assignment";
import { Temporal } from "temporal-polyfill-lite";
// Utility
import cloneDeep from "lodash/cloneDeep";
export class UserAssignment extends Assignment {
    mapEntityChangesToResource(changed, source) {
        return {
        };
    }
    mapDeltaChangesToEntity(delta) {
        return this.processDeltaWithTranslators(delta, {
            assignedDateTime: (value)=>value ? Temporal.Instant.from(value) : undefined,
            completedDateTime: (value)=>value ? Temporal.Instant.from(value) : null
        });
    }
    static fromResource(resource) {
        return new UserAssignment({
            id: resource.id,
            version: resource["@etag"],
            user: resource.user,
            assignedBy: resource.assignedBy,
            assignedDateTime: Temporal.Instant.from(resource.assignedDateTime),
            percentComplete: resource.percentComplete ?? 0,
            completedBy: resource.completedBy ?? null,
            completedDateTime: resource.completedDateTime ? Temporal.Instant.from(resource.completedDateTime) : null
        });
    }
    forSerialization() {
        return {
            ...super.forSerialization(),
            user: this.user
        };
    }
    getClone() {
        return new UserAssignment({
            ...super.getClone(),
            user: cloneDeep(this.user)
        });
    }
    setProperty(key, value) {
        const clone = this.getClone();
        clone[key] = value;
        return clone;
    }
    forCreate() {
        return {
            user: {
                id: this.user.id
            }
        };
    }
    constructor(propertyBag){
        super(propertyBag);
        this.user = propertyBag.user;
    }
}
